import { render } from "./PurchasePaymentReportContent.vue?vue&type=template&id=50973a46&scoped=true&ts=true"
import script from "./PurchasePaymentReportContent.vue?vue&type=script&lang=ts"
export * from "./PurchasePaymentReportContent.vue?vue&type=script&lang=ts"

import "./PurchasePaymentReportContent.vue?vue&type=style&index=0&id=50973a46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50973a46"]])

export default __exports__